import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isIFrameSameOrigin } from '../../../shared/helpers/is-same-origin';
import { OeAppService } from '../../../shared/oe-app.service';
import { WindowService } from '../../../shared/window.service';
import { CohortSelectionModalEvent } from './cohort-selection-modal-events';
import { GTMService } from '../../../shared/gtm.service';

@Component({
  selector: 'lp2-cohort-selection-modal',
  template: '<iframe lp2UserwaySync [src]="url | safeUrl"></iframe>',
  styleUrls: ['./cohort-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'cohort-selection-modal',
  },
})
export class CohortSelectionModalComponent implements OnInit {
  public url: string;

  constructor(
    private oeAppService: OeAppService,
    private modal: NgbActiveModal,
    private windowService: WindowService,
    private gtmService: GTMService
  ) {}

  public ngOnInit(): void {
    this.setUrl();
    window.addEventListener('message', this.handleEvents.bind(this));
  }

  private setUrl() {
    this.url = `${this.oeAppService.webLiveClassScheduleSelectionPageHost}?env=${this.oeAppService.environment}`;
  }

  private handleEvents = ({ data, origin }) => {
    if (!isIFrameSameOrigin(this.oeAppService.webLiveClassScheduleSelectionPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case CohortSelectionModalEvent.LIVE_CLASS_SCHEDULE_SELECTION_CLOSE_WITH_SUCCESS_EVENT:
        this.modal.close();
        this.windowService.redirectToHref('/');
        break;
      case CohortSelectionModalEvent.LIVE_CLASS_SCHEDULE_SELECTION_TRACKING_EVENT:
        this.gtmService.sendGA4Event(data.data);
        break;
    }
  };
}



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort-selection-modal/cohort-selection-modal.component.ts